module.exports = __webpack_public_path__ + "img/grade_D.c4527d1.svg";